import { useEffect, useMemo, useState } from "react"
import Button from "../../../button/button"
import InputAnimated from "../../../inputAnimated/inputAnimated"
import Modal from "../../../modal/modal"
import './CashAudit.scss'
import PrintCashAudit from "./PrintCashAudit/PrintCashAudit"
import { useNavigate } from "react-router-dom"
import Axios from "axios"
import Alert from "../../../alert/Alert"
import { formatDate3 } from "../../../functions/DateFunctions/DateFunctions"
import { GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary } from "../../../../utils/Apis/receptionApis"
import SelectSubsidiary from "../PaymentReceipt/SelectSubsidiary/SelectSubsidiary";
import { formatToLocalDateTime } from "../../../../utils/dateTimeZone";
import { GetCurrency } from "../../../../utils/Apis/apis"
const CashAudit = ({ onClose, isOpen, usr, listSubsidiary }) => {
    const navigate = useNavigate();

    //state to open print audit
    const [isOpenPrintAudit, setIsOpenPrintAudit] = useState(false);
    const [searchCurrency, setSearchCurrency] = useState(false)
    const [receiptPaymentsSummary, setReceiptPaymentsSummary] = useState({
        card_credit_total: 0,
        card_debit_total: 0,
        transfer_total: 0,
        cash_mxn: 0,
        cash_usd: 0,
        total_amount: 0,
        total_amount_only_mxn: 0,
        receipt_ids: [],
        subsidiary_id: '',
        usd_to_mxn: 0,
        receptionist: { id: "", name: "" },
        start_datetime: null,  // Nuevo campo
        end_datetime: null,     // Nuevo campo
        average_usd_exchange_rate: 0,

    })
    const [cashRecived, setCashRecived] = useState({
        cashbox: '',
        mxn: '',
        usd: ''
    })
    const [openModalSubsidiaryReceipts, setOpenModalSubsidiaryReceipts] = useState(false)

    const [cashAudited, setcashAudited] = useState(false)
    const [subsidiaryReady, setSubsidiaryReady] = useState(false);
    ////Alert
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    const [subsidiaryToCreateCashAuditName, setSubsidiaryToCreateCashAuditName] = useState('')
    const [totalOnlyCash, setTotalOnlyCash] = useState(0)


    useEffect(() => {
        if (receiptPaymentsSummary.average_usd_exchange_rate === 0 && receiptPaymentsSummary.receipt_ids.length !== 0) {
            const controller = new AbortController();

            const fetchData = async () => {
                try {
                    const [currencyResponse] = await Promise.all([GetCurrency()]);

                    if (controller.signal.aborted) return;

                    if (currencyResponse.auth === false) {
                        navigate("/login");
                        return;
                    }
                    // Buscar la tasa de USD
                    const usdCurrency = currencyResponse.result.find(v => v.name === 'USD');
                    if (usdCurrency) {
                        // Aquí actualizamos receiptPaymentsSummary con el valor nuevo
                        setReceiptPaymentsSummary(prev => ({
                            ...prev,
                            average_usd_exchange_rate: usdCurrency.exchange_rate
                        }));
                    }
                } catch (err) {
                    if (!controller.signal.aborted) {
                        // setError("Error al cargar los datos");
                    }
                } finally {
                    if (!controller.signal.aborted) {
                        // setLoading(false);
                    }
                }
            };

            fetchData();

            return () => {
                controller.abort();
            };
        }
    }, [searchCurrency]);
    useEffect(() => {
        const fetchCashAudit = async () => {
            if (localStorage.getItem('receptionSubsidiarySession')) {
                const subsidiaryIdToSearchReceipts = localStorage.getItem('receptionSubsidiarySession')
                const CashAuditVerify = await GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary(subsidiaryIdToSearchReceipts, usr.employee_id);
                const selectedSubsidiary = listSubsidiary.find(sub => parseInt(sub.value) === parseInt(subsidiaryIdToSearchReceipts));
                const subsidiaryName = selectedSubsidiary?.label || "Sucursal desconocida";
                setSubsidiaryToCreateCashAuditName(subsidiaryName)
                if (CashAuditVerify.status === 200) {
                    setSearchCurrency(!searchCurrency)
                    setReceiptPaymentsSummary({
                        ...CashAuditVerify.summary,
                        receptionist: {
                            id: `${usr.employee_id}`,
                            name: `${usr.name} ${usr.middle_name} ${usr.last_name}`
                        }
                    })
                }

            } else {
                setOpenModalSubsidiaryReceipts(true)
            }
        };
        fetchCashAudit();
    }, [subsidiaryReady])

    useEffect(() => {
        const totalOnlyCash = receiptPaymentsSummary.cash_mxn + receiptPaymentsSummary.usd_to_mxn
        setTotalOnlyCash(totalOnlyCash)
    }, [receiptPaymentsSummary])
    // Esta función la puedes llamar desde tu modal cuando se cree el localStorage:
    const handleSubsidiarySaved = () => {
        setSubsidiaryReady(prev => !prev); // Al cambiar, el useEffect se ejecuta otra vez
    };

    const handleOpenPrintAudit = async () => {
        if (receiptPaymentsSummary.receipt_ids.length === 0) {
            return showAlert('No hay recibos que auditar', 'danger')
        }
        const mxn = parseFloat(cashRecived.mxn) || 0;
        const usd = parseFloat(cashRecived.usd) || 0;
        if (totalOnlyCash !== 0) {
            if (mxn === 0 && usd === 0) {
                return showAlert('Debe ingresar efectivo en MXN o USD para continuar con el corte.', 'danger');
            }
        }

        const createCashAudit = await PostCreateCashAudit()
        if (createCashAudit.status === 200) {
            showAlert(`${createCashAudit.message}`, 'success')
            setcashAudited(true)
            const folio = createCashAudit.id || ''
            const dateObj = new Date(createCashAudit.datetime);
            const pad = n => n.toString().padStart(2, '0');
            const localDatetime = `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ` +
                `${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
            setReceiptPaymentsSummary(prev => ({
                ...prev,
                date_time: localDatetime,
                folio: folio,
                cash_mxn_received: mxn,
                cash_usd_received: usd,
                total_amount_received: totalImporte,
                subsidiary_name: subsidiaryToCreateCashAuditName,
                discrepancy: differenceAmount,
            }))
            setIsOpenPrintAudit(true);

        } else {
            showAlert(`${createCashAudit.message}`, 'danger')

        }
    }
    // Función para mostrar alertas
    const showAlert = (msg, type) => {
        const id = Math.floor(Math.random() * 100) + 1;
        setArrayAlerts(oldArray => [...oldArray, { id, message: msg, type }]);
        setIsVisibleAlert(true);
    };
    const handleClosePrintAudit = () => {
        setIsOpenPrintAudit(false);
    }

    const PostCreateCashAudit = async () => {
        try {
            const res = await Axios.post(
                process.env.REACT_APP_API_URL + "postCreateCashAudit/",
                {
                    subsidiary_id: receiptPaymentsSummary.subsidiary_id,
                    cash_mxn: receiptPaymentsSummary.cash_mxn,
                    cash_usd: receiptPaymentsSummary.cash_usd,
                    usd_to_mxn: receiptPaymentsSummary.usd_to_mxn,
                    exchange_rate: receiptPaymentsSummary.average_usd_exchange_rate,
                    cash_mxn_received: cashRecived.mxn,
                    cash_usd_received: cashRecived.usd,
                    card_debit_total: receiptPaymentsSummary.card_debit_total,
                    card_credit_total: receiptPaymentsSummary.card_credit_total,
                    transfer_total: receiptPaymentsSummary.transfer_total,
                    total_amount: receiptPaymentsSummary.total_amount,
                    total_amount_received: totalImporte,
                    discrepancy: differenceAmount,
                    receipt_ids: receiptPaymentsSummary.receipt_ids,
                    receptionist: receiptPaymentsSummary.receptionist
                },
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                    },
                }
            );
            return res.data;
        } catch (error) {
            console.error("Error recibiendo recibos de pago:", error);
            return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
        }
    };


    const handleChangeCash = async (e) => {
        const { name, value } = e.target
        setCashRecived(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const totalImporte = useMemo(() => {
        return (
            Number(cashRecived.mxn || 0) +
            Number((cashRecived.usd * receiptPaymentsSummary.average_usd_exchange_rate) || 0) +
            Number(receiptPaymentsSummary.card_credit_total || 0) +
            Number(receiptPaymentsSummary.card_debit_total || 0) +
            Number(receiptPaymentsSummary.transfer_total || 0)
        );
    }, [cashRecived, receiptPaymentsSummary]);

    const differenceAmount = useMemo(() => {
        const realTotal = Number(receiptPaymentsSummary.total_amount || 0);
        const inputTotal = Number(totalImporte || 0);
        const diff = inputTotal - realTotal;
        return parseFloat(diff.toFixed(2));
    }, [receiptPaymentsSummary.total_amount, totalImporte]);

    const total_MXN_plus_USD_to_MXN_real = useMemo(() => {
        return (
            Number(cashRecived.mxn || 0) +
            Number((cashRecived.usd * receiptPaymentsSummary.average_usd_exchange_rate) || 0)
        )
    }, [cashRecived])

    const handleCloseModalToReceiptsSubsidiarySelect = () => {
        setOpenModalSubsidiaryReceipts(false)
        handleSubsidiarySaved(); // Esto forza el re-fetch
    }
    return (
        <>
            <Modal overlayClick={false} isOpen={isOpen}>
                <div className="cash-audit">
                    <h1 className="title-1">Corte de caja</h1>
                    <h1 className="emphasis-1">Recepcionista: {(receiptPaymentsSummary.receptionist.name)}</h1>
                    <InputAnimated disabled={true} name={'subsidiary'} type="text" placeholder={'Sucursal'} value={subsidiaryToCreateCashAuditName} />
                    {/* <InputAnimated disabled={cashAudited} name={'cashbox'} type="number" placeholder={'Fondo de caja'} value={cashRecived.cashbox} onChange={handleChangeCash} /> */}
                    <h1 className="title-2">Efectivo recibido</h1>
                    <InputAnimated disabled={cashAudited} name={'mxn'} type="number" placeholder={'Moneda nacional'} value={cashRecived.mxn} onChange={handleChangeCash} />
                    <h1 className="emphasis-1">Dolar calculado en: ${receiptPaymentsSummary.average_usd_exchange_rate} MXN</h1>
                    <InputAnimated disabled={cashAudited} name={'usd'} type="number" placeholder={'Dolar'} value={cashRecived.usd} onChange={handleChangeCash} />
                    <h1 className="emphasis-1">Total efectivo sistema MXN: {totalOnlyCash}</h1>
                    <h1 className="emphasis-1">Total efectivo REAL MXN: {total_MXN_plus_USD_to_MXN_real}</h1>
                    <h1 className="title-2">Total pagos con tarjeta</h1>
                    <InputAnimated type="number" placeholder={'Cantidad'} value={(receiptPaymentsSummary.card_credit_total + receiptPaymentsSummary.card_debit_total)} readOnly />
                    <h1 className="title-2">Total pagos con transferencia</h1>
                    <InputAnimated type="number" placeholder={'Cantidad'} value={receiptPaymentsSummary.transfer_total} readOnly />
                    <div className="cash-audit-summary">
                        <h1 className="title-3">Importe total</h1>
                        <InputAnimated type="number" placeholder={'Importe total'} value={totalImporte} readOnly />
                        <h1 className={`emphasis-1 ${differenceAmount < 0 ? 'text-red' : 'text-green'}`}>
                            {differenceAmount !== 0
                                ? `Descuadre: ${differenceAmount > 0 ? '+$' : ''}${differenceAmount}`
                                : '✔ Sin descuadre'}
                        </h1>
                    </div>

                    <div className="confirm-buttons-section">
                        <Button text={!cashAudited ? "Cancelar" : "Cerrar"} backgroundColor="red" onClick={onClose} />
                        <Button text="Confirmar" onClick={handleOpenPrintAudit} disabled={cashAudited} />
                        <Button text={"Re-Imprimir"} disabled={!cashAudited} onClick={() => {
                            setIsOpenPrintAudit(true);
                        }} />
                    </div>
                </div>
            </Modal>
            {isOpenPrintAudit && <PrintCashAudit isOpen={isOpenPrintAudit} onClose={handleClosePrintAudit} auditData={receiptPaymentsSummary} />}
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>

            <SelectSubsidiary
                isOpen={openModalSubsidiaryReceipts}
                onClose={handleCloseModalToReceiptsSubsidiarySelect}
                job_position="reception"
            />
        </>
    )
}
export default CashAudit